var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"activation-toggle"},[_c('label',{staticClass:"toggle-switch"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isActive},on:{"change":_vm.handleToggle}}),_c('span',{staticClass:"toggle-slider"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }